// extracted by mini-css-extract-plugin
export var fadeIn = "_1w-0";